export const reset = (state, payload) => {
  state.list = {};
};
